<style >
 .ag-textfield  textarea{ line-height: 1.5em !important; }
</style>
<template>
<v-card flat >
  <v-card outlined @click="editdialog=true" >
    <v-btn fab top right x-small absolute class="mt-5" ><v-icon>mdi-pencil</v-icon></v-btn>
    <span v-if="label"
      class="ml-4 text-decoration-underline grey--text" >{{label}}:</span>
    <v-divider/>
    <v-card-text class="pt-1" >
      <!-- style="line-height:1.1em;overflow:scroll;" -->
      <pre v-text="text" class="text-caption" style="white-space: pre-wrap;" />

    </v-card-text>
    <v-divider/>
    <v-card-title class="pa-0 grey lighten-4" >
      <v-spacer/>
      <v-btn x-small text >Click to edit</v-btn>
    </v-card-title>
  </v-card>
  <v-dialog v-model="editdialog" width="640" >
    <v-card >
      <v-card-title class="grey lighten-4 overline py-1" >
        Edit
        <v-spacer/>
        <v-btn @click="editdialog=false" small icon ><v-icon small >mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4 ag-textfield" >
        <v-textarea auto-grow outlined counter
          v-model="text"
          :label="label"
          ref="textarea"
          rows="8"
          class="caption" />

        <slot name="mergetags" >

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon small>mdi-call-merge</v-icon>
                <span>
                  Merge tags
                </span>
                <small >
                  Expand to find variables you can use in your notification to insert information from your appointment
                </small>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card outlined >
                  <v-alert text tile class="py-1 caption" type="info" border="left" >
                    Merge tags allow you to include variables from your appointment into your notifications,
                    Click on the chip to add the variable to your message
                  </v-alert>
                  <v-card-text >
                    <div><strong>Appointment</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.formatted_appointment_for_client}}')" >
                      Formatted appointment information
                    </v-chip>
                    <div><strong>Client</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{client.first_name}}')" >Client's first name</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{client.last_name}}')" >Client's last name</v-chip>

                    <div><strong>Practitioner</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{me.get_full_name}}')" >Practitioner's full name</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{me.first_name}}')" >Practitioner's first name</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{me.last_name}}')" >Practitioner's last name</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{me.profession_name}}')" >Practitioner's profession</v-chip>

                    <div><strong>Date/time</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.starttime_formatted.zoned_date_formatted}}')" >Appointment start date</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.starttime_formatted.zoned_time_formatted}}')" >Appointment start time</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.product_name}}')" >Appointment type</v-chip>

                    <div><strong>Space</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.space_name}}')" >Space name</v-chip>

                    <div><strong>Location</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.address_name}}')" >Location name</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.address_address}}')" >Location address</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.address_map_link}}')" >Location link</v-chip>

                    <div><strong>Links</strong></div>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.formatted_forms_to_show}}')" >Link to forms</v-chip>
                    <v-chip small class="mr-1 mb-1" @click="execInsertText('{{appointment.client_detail_url}}')" >Link to appointment</v-chip>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </slot>
      </v-card-text>
      <v-card-actions >
        <v-spacer/>
        <v-btn
          @click="editdialog=false;$emit('input', text);$emit('saved', text)"
          color="primary" class="mr-4" >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>

</template>
<script>
export default {
  name: 'AgTextfield',
  props: {
    label: { type: String },
    value: { type: String }
  },
  data () {
    return {
      text: null,
      editdialog: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.text = this.value
      }
    },
    text () {
      this.$emit('input', this.text)
    }
  },
  methods: {
    execInsertText(insertText) {
      if (!insertText.length) return

      const textarea = this.$refs.textarea.$refs.input
      const sentence = textarea.value
      const len = sentence.length
      let pos = textarea.selectionStart
      if (pos === undefined) {
        pos = 0
      }

      const before = sentence.substr(0, pos)
      const after = sentence.substr(pos, len)

      this.text = before + insertText + after

      this.$nextTick().then(() => {
        textarea.selectionStart = pos + insertText.length
      })
    }
  }
}
</script>
